export default{
    isPc() {
     //先判断是否为微信内置浏览器
    //  var ua=window.navigator.userAgent.toLowerCase();
    //  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    //    return false;  //认为是移动设备
    // }
    var userAgentInfo = navigator.userAgent;
    var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = false; break; }
    }
    return flag;
   }
}